import axios from "axios";


//get videos table
export const getContent = async () => {
    try {
  
       const res = await axios({
            method: "POST",
            url: "http://3.233.136.161:8888/videos",
          });
  
        return await res.data;
    } catch (error) {
        console.log(error);
    }
};


// delete video by tag id
export const deleteVideos = async (bodyFormData) => {
  try {
     const res = await axios({
          method: "POST",
          url: "http://3.233.136.161:8888/delete",
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        return res.data.status
  } catch (error) {
      console.log(error);
  }
};

//create video
export const createVideos = async (bodyFormData) => {
    try {
       const res = await axios({
            method: "POST",
            url: "http://3.233.136.161:8888/create",
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
          });
          return res.data.status
    } catch (error) {
        console.log(error);
    }
};

// update video tag after edit
export const updateVideos = async (bodyFormData) => {
    try {
       const res = await axios({
            method: "POST",
            url: "http://3.233.136.161:8888/update",
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
          });
          return res.data.status
    } catch (error) {
        console.log(error);
    }
};